import { createAction, handleActions } from "redux-actions";

import { NOTIFICATION_TYPES } from "../../../lib/getStockPageSectionFromNotificationType";
import { createRoutine } from "redux-saga-routines";
import { cloneDeep } from "lodash";
import moment from "moment-mini";
import { PLAN_PERMISSIONS_SECTIONS } from "../auth/userPermissions/selector";

export const FETCH_NOTIFICATIONS = "app/newNotifications/FETCH_NOTIFICATIONS";

export const fetchNotifications = createRoutine(FETCH_NOTIFICATIONS);

export const FETCH_MORE_NOTIFICATIONS =
  "app/newNotifications/FETCH_MORE_NOTIFICATIONS";
export const fetchMoreNotifications = createRoutine(FETCH_MORE_NOTIFICATIONS);

export const SET_FILTER = "app/newNotifications/SET_FILTER";
export const setFilter = createAction(SET_FILTER, (name, value) => ({
  name,
  value
}));

export const CLEAR_NOTIFICATIONS = "app/newNotifications/CLEAR_NOTIFICATIONS";
export const clearNotifications = createAction(CLEAR_NOTIFICATIONS, () => {});

export const SET_ALL_FILTERS = "app/newNotifications/SET_ALL_FILTERS";
export const setAllFilters = createAction(SET_ALL_FILTERS, (names, value) => ({
  names,
  value
}));

export const SET_FILTERS = "app/newNotifications/SET_FILTERS";
export const setFilters = createAction(SET_FILTERS, filters => ({
  filters
}));

export const RESET_FILTERS = "app/newNotifications/RESET_FILTERS";
export const resetFilters = createAction(RESET_FILTERS);

export const SET_GLOBAL_LOADING = "app/newNotifications/SET_GLOBAL_LOADING";
export const setGlobalLoading = createAction(SET_GLOBAL_LOADING, value => ({
  value
}));

export const SET_SELECTED_TAB = "app/newNotifications/SET_SELECTED_TAB";
export const setSelectedTab = createAction(SET_SELECTED_TAB, name => ({
  name
}));

export const MARK_AS_READ = "app/newNotifications/MARK_AS_READ";
export const markAsRead = createRoutine(MARK_AS_READ);

export const ADD_NOTIFICATION = "app/newNotifications/ADD_NOTIFICATION";
export const addNotification = createAction(ADD_NOTIFICATION, notification => ({
  notification
}));

export const NOTIFICATIONS_TAB_STYLES_TYPES = {
  DEFAULT: "DEFAULT",
  YELLOW: "YELLOW"
};

export const initialState = {
  initialFetchComplete: false,
  globalLoading: false,
  selectedTabName: "All",
  filters: {
    searchQuery: {
      value: ""
    },
    showOnlyUnread: {
      value: false
    },
    [NOTIFICATION_TYPES.STOCK_ANALYSIS_CATEGORY_TECHNICAL_ANALYSIS]: {
      value: true,
      type: "checkbox"
    },
    [NOTIFICATION_TYPES.STOCK_ANALYSIS_CATEGORY_SHORT_TECHNICAL_ANALYSIS]: {
      value: true,
      type: "checkbox"
    },
    [NOTIFICATION_TYPES.STOCK_ANALYSIS_CATEGORY_VIDEO_ANALYSIS]: {
      value: true,
      type: "checkbox"
    },
    [NOTIFICATION_TYPES.STOCK_ANALYSIS_CATEGORY_FINANCIAL_ANALYSIS]: {
      value: true,
      type: "checkbox"
    },
    [NOTIFICATION_TYPES.STOCK_ANALYSIS_CATEGORY_MORNING_BRIEF]: {
      value: true,
      type: "checkbox"
    },
    [NOTIFICATION_TYPES.MEDIA_MONITOR]: {
      value: true,
      type: "checkbox"
    },
    [NOTIFICATION_TYPES.RECOMMENDATIONS]: {
      value: true,
      type: "checkbox"
    },
    [NOTIFICATION_TYPES.PRICE_ALERTS]: {
      value: true,
      type: "checkbox"
    },
    [NOTIFICATION_TYPES.DONCHAIN_H4]: {
      value: true,
      type: "checkbox"
    },
    [NOTIFICATION_TYPES.DEMAND_ZONE]: {
      value: true,
      type: "checkbox"
    },
    [NOTIFICATION_TYPES.WEBINAR]: {
      value: true,
      type: "checkbox"
    },
    [NOTIFICATION_TYPES.EDUCATION_EVENT]: {
      value: true,
      type: "checkbox"
    },
    [NOTIFICATION_TYPES.SPECIAL_OFFER]: {
      value: true,
      type: "checkbox"
    },
    [NOTIFICATION_TYPES.THIRD_PARTY_OFFERING]: {
      value: true,
      type: "checkbox"
    },
    [NOTIFICATION_TYPES.INSIDER_ANALYSIS_CATEGORY_ANALYSIS]: {
      value: true,
      type: "checkbox"
    },
    [NOTIFICATION_TYPES.INSIDER_ANALYSIS_CATEGORY_RECOMMENDATION]: {
      value: true,
      type: "checkbox"
    },
    [NOTIFICATION_TYPES.HIGHS_AND_LOWS_CORRECTION]: {
      value: true,
      type: "checkbox"
    },
    [NOTIFICATION_TYPES.HIGHS_AND_LOWS_SUMMARY]: {
      value: true,
      type: "checkbox"
    },
    [NOTIFICATION_TYPES.TRANSACTION_STRATEGY_HIGHS_AND_LOWS]: {
      value: true,
      type: "checkbox"
    },
    [NOTIFICATION_TYPES.TRANSACTION_STRATEGY_SUPPLY_DEMAND]: {
      value: true,
      type: "checkbox"
    },
    [NOTIFICATION_TYPES.TRANSACTION_STRATEGY_TREND]: {
      value: true,
      type: "checkbox"
    }
  },
  notificationsTabs: [
    {
      notificationTypes: [],
      takeSumOfEnabledNotificationTypes: true,
      name: "All",
      notifications: [],
      loading: false,
      unreadCount: 0,
      endReached: false,
      permissions: [],
      order: 0,
      orderNoPermission: 0,
      styleType: NOTIFICATIONS_TAB_STYLES_TYPES.DEFAULT
    },
    {
      notificationTypes: [
        {
          notificationType:
            NOTIFICATION_TYPES.STOCK_ANALYSIS_CATEGORY_TECHNICAL_ANALYSIS
        },
        {
          notificationType:
            NOTIFICATION_TYPES.STOCK_ANALYSIS_CATEGORY_SHORT_TECHNICAL_ANALYSIS
        },
        {
          notificationType:
            NOTIFICATION_TYPES.STOCK_ANALYSIS_CATEGORY_VIDEO_ANALYSIS
        },
        {
          notificationType:
            NOTIFICATION_TYPES.STOCK_ANALYSIS_CATEGORY_FINANCIAL_ANALYSIS
        },
        {
          notificationType:
            NOTIFICATION_TYPES.STOCK_ANALYSIS_CATEGORY_MORNING_BRIEF
        }
      ],
      takeSumOfEnabledNotificationTypes: false,
      name: "Signals and Analysis",
      notifications: [],
      loading: false,
      unreadCount: 0,
      endReached: false,
      permissions: [],
      order: 100,
      orderNoPermission: 100,
      styleType: NOTIFICATIONS_TAB_STYLES_TYPES.DEFAULT
    },
    {
      notificationTypes: [
        { notificationType: NOTIFICATION_TYPES.MEDIA_MONITOR },
        { notificationType: NOTIFICATION_TYPES.RECOMMENDATIONS }
      ],
      takeSumOfEnabledNotificationTypes: false,
      name: "Information from companies",
      notifications: [],
      loading: false,
      unreadCount: 0,
      endReached: false,
      permissions: [],
      order: 200,
      orderNoPermission: 200,
      styleType: NOTIFICATIONS_TAB_STYLES_TYPES.DEFAULT
    },
    {
      notificationTypes: [
        { notificationType: NOTIFICATION_TYPES.PRICE_ALERTS }
      ],
      takeSumOfEnabledNotificationTypes: false,
      name: "Price Alerts",
      notifications: [],
      loading: false,
      unreadCount: 0,
      endReached: false,
      permissions: [],
      order: 300,
      orderNoPermission: 300,
      styleType: NOTIFICATIONS_TAB_STYLES_TYPES.DEFAULT
    },
    {
      notificationTypes: [
        { notificationType: NOTIFICATION_TYPES.DONCHAIN_H4 },
        { notificationType: NOTIFICATION_TYPES.DEMAND_ZONE },
        {
          notificationType: NOTIFICATION_TYPES.HIGHS_AND_LOWS_CORRECTION
        },
        {
          notificationType: NOTIFICATION_TYPES.HIGHS_AND_LOWS_SUMMARY
        },
        {
          notificationType:
            NOTIFICATION_TYPES.TRANSACTION_STRATEGY_HIGHS_AND_LOWS
        },
        {
          notificationType:
            NOTIFICATION_TYPES.TRANSACTION_STRATEGY_SUPPLY_DEMAND
        },
        {
          notificationType: NOTIFICATION_TYPES.TRANSACTION_STRATEGY_TREND
        }
      ],
      takeSumOfEnabledNotificationTypes: false,
      name: "Strategies",
      notifications: [],
      loading: false,
      unreadCount: 0,
      endReached: false,
      permissions: [],
      order: 400,
      orderNoPermission: 400,
      styleType: NOTIFICATIONS_TAB_STYLES_TYPES.DEFAULT
    },
    {
      notificationTypes: [
        {
          notificationType:
            NOTIFICATION_TYPES.INSIDER_ANALYSIS_CATEGORY_ANALYSIS
        },
        {
          notificationType:
            NOTIFICATION_TYPES.INSIDER_ANALYSIS_CATEGORY_RECOMMENDATION
        }
      ],
      takeSumOfEnabledNotificationTypes: false,
      name: "Insider",
      notifications: [],
      loading: false,
      unreadCount: 0,
      endReached: false,
      permissions: [
        ...PLAN_PERMISSIONS_SECTIONS.INSIDER_ANALYSES_AND_RECOMMENDATIONS
      ],
      order: 1,
      orderNoPermission: 500,
      styleType: NOTIFICATIONS_TAB_STYLES_TYPES.YELLOW
    },
    {
      notificationTypes: [
        { notificationType: NOTIFICATION_TYPES.WEBINAR },
        { notificationType: NOTIFICATION_TYPES.EDUCATION_EVENT },
        { notificationType: NOTIFICATION_TYPES.SPECIAL_OFFER },
        { notificationType: NOTIFICATION_TYPES.THIRD_PARTY_OFFERING }
      ],
      takeSumOfEnabledNotificationTypes: false,
      name: "More1",
      notifications: [],
      loading: false,
      unreadCount: 0,
      endReached: false,
      permissions: [],
      order: 600,
      orderNoPermission: 600,
      styleType: NOTIFICATIONS_TAB_STYLES_TYPES.DEFAULT
    }
  ]
};

export default handleActions(
  {
    [fetchNotifications.TRIGGER]: state => {
      const newNotificationsTabs = [];

      for (const tab of state.notificationsTabs) {
        newNotificationsTabs.push({ ...tab, loading: true });
      }

      return { ...state, notificationsTabs: newNotificationsTabs };
    },
    [fetchNotifications.SUCCESS]: (state, { payload }) => {
      const selectedTabExists = payload.some(
        ({ name }) => name === state.selectedTabName
      );

      return {
        ...state,
        notificationsTabs: payload,
        selectedTabName: selectedTabExists
          ? state.selectedTabName
          : payload?.[0]?.name ?? state.selectedTabName,
        initialFetchComplete: true
      };
    },
    [fetchNotifications.FAILURE]: state => {
      const newNotificationsTabs = [];

      for (const tab of state.notificationsTabs) {
        newNotificationsTabs.push({ ...tab, loading: false });
      }

      return { ...state, notificationsTabs: newNotificationsTabs };
    },
    [fetchMoreNotifications.TRIGGER]: (state, { payload }) => {
      const newNotificationsTabs = [];

      for (const tab of state.notificationsTabs) {
        if (tab.name === payload.name) {
          newNotificationsTabs.push({ ...tab, loading: true });
          continue;
        }

        newNotificationsTabs.push(tab);
      }

      return { ...state, notificationsTabs: newNotificationsTabs };
    },
    [fetchMoreNotifications.SUCCESS]: (state, { payload }) => {
      const newNotificationsTabs = [];

      for (const tab of state.notificationsTabs) {
        if (tab.name === payload.name) {
          newNotificationsTabs.push(payload);
          continue;
        }

        newNotificationsTabs.push(tab);
      }

      return { ...state, notificationsTabs: newNotificationsTabs };
    },
    [fetchMoreNotifications.FAILURE]: state => {
      const newNotificationsTabs = [];

      for (const tab of state.notificationsTabs) {
        newNotificationsTabs.push({ ...tab, loading: false });
      }

      return { ...state, notificationsTabs: newNotificationsTabs };
    },
    [markAsRead.TRIGGER]: state => {
      return state;
    },
    [markAsRead.SUCCESS]: (state, { payload }) => {
      const newNotificationsTabs = cloneDeep(state.notificationsTabs);

      if (payload.id) {
        for (const tab of newNotificationsTabs) {
          const index = tab.notifications.findIndex(
            ({ id }) => id === payload.id
          );

          if (index === -1) {
            continue;
          }

          if (typeof tab.notifications[index]?.read !== "undefined") {
            tab.notifications[index].read = true;
          }

          if (tab.unreadCount > 0) {
            tab.unreadCount--;
          }
        }
      }

      return { ...state, notificationsTabs: newNotificationsTabs };
    },
    [markAsRead.FAILURE]: state => {
      return state;
    },
    [SET_FILTER]: (state, { payload }) => {
      const { name, value } = payload;

      const filters = { ...state.filters };
      const filter = filters[name];

      if (typeof filter === "undefined") {
        return state;
      }

      filters[name] = { ...filter, value: value };

      return {
        ...state,
        filters: filters
      };
    },
    [SET_ALL_FILTERS]: (state, { payload }) => {
      const { names, value } = payload;

      if (!Array.isArray(names)) {
        return state;
      }

      const filters = { ...state.filters };

      for (const name of names) {
        const filter = filters[name];

        if (typeof filter === "undefined") {
          continue;
        }

        filters[name] = { ...filter, value: value };
      }

      return {
        ...state,
        filters: filters
      };
    },
    [SET_FILTERS]: (state, { payload }) => {
      const filtersState = payload?.filters;

      if (!filtersState || typeof filtersState !== "object") {
        return state;
      }

      const filters = { ...state.filters };

      for (const [name, value] of Object.entries(filtersState)) {
        const filter = filters[name];

        if (typeof filter === "undefined") {
          continue;
        }

        filters[name] = { ...filter, value: Boolean(value) };
      }

      return {
        ...state,
        filters
      };
    },
    [RESET_FILTERS]: state => {
      return {
        ...state,
        filters: cloneDeep(initialState.filters)
      };
    },
    [SET_SELECTED_TAB]: (state, { payload }) => {
      const name = payload?.name;

      if (!name) {
        return state;
      }

      return {
        ...state,
        selectedTabName: name
      };
    },
    [SET_GLOBAL_LOADING]: (state, { payload }) => {
      return {
        ...state,
        globalLoading: Boolean(payload?.value)
      };
    },
    [CLEAR_NOTIFICATIONS]: () => {
      return initialState;
    },
    [ADD_NOTIFICATION]: (state, { payload }) => {
      const notification = {
        ...payload.notification,
        date: payload.notification.date || moment().format()
      };

      const notificationsTabs = cloneDeep(state.notificationsTabs);

      notificationsTabs.forEach(tab => {
        if (
          tab.notificationTypes.length === 0 ||
          tab.notificationTypes.filter(
            type => type?.notificationType === notification?.notification_type
          ).length > 0
        ) {
          tab.notifications = [notification, ...tab.notifications];
          tab.unreadCount += 1;
        }
      });

      return {
        ...state,
        notificationsTabs
      };
    }
  },
  initialState
);
